var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComponent3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 510,
    height: 499,
    viewBox: "0 0 510 499",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.587 207.783H42.6756C35.1787 207.783 28.6918 201.705 28.1868 194.208L20.878 85.6486C20.373 78.1517 26.041 72.0742 33.5379 72.0742H186.449C193.946 72.0742 200.433 78.1517 200.938 85.6486L208.247 194.208C208.752 201.705 203.084 207.783 195.587 207.783Z",
    stroke: "#8DDCFC",
    strokeWidth: 2.65637,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M205.002 197.728H52.0912C44.5943 197.728 38.1073 191.651 37.6023 184.154L30.2935 75.5939C29.7885 68.097 35.4565 62.0195 42.9534 62.0195H195.865C203.362 62.0195 209.848 68.097 210.353 75.5939L217.663 184.154C218.167 191.651 212.499 197.728 205.002 197.728Z",
    fill: "#8DDCFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0811 78.8874C59.0811 84.1373 54.8248 88.3945 49.573 88.3945C44.3221 88.3945 40.0668 84.1373 40.0668 78.8874C40.0668 73.6365 44.3221 69.3793 49.573 69.3793C54.8248 69.3793 59.0811 73.6365 59.0811 78.8874Z",
    fill: "#E9F9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5749 80.4922C50.1371 80.4922 50.6182 80.2917 51.0191 79.8908C51.42 79.4909 51.6195 79.0088 51.6195 78.4466V75.1745C51.6195 74.6122 51.42 74.1312 51.0191 73.7303C50.6182 73.3294 50.1371 73.1289 49.5749 73.1289C49.0126 73.1289 48.5306 73.3294 48.1307 73.7303C47.7297 74.1302 47.5293 74.6122 47.5293 75.1745V78.4466C47.5293 79.0088 47.7297 79.4909 48.1307 79.8908C48.5306 80.2917 49.0126 80.4922 49.5749 80.4922Z",
    fill: "#16B4F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1332 77.3409C53.053 77.2598 52.9566 77.2188 52.8458 77.2188C52.7351 77.2188 52.6387 77.2598 52.5576 77.3409C52.4774 77.4211 52.4373 77.5175 52.4373 77.6282V78.4463C52.4373 79.2338 52.1567 79.9086 51.5964 80.4689C51.0361 81.0292 50.3622 81.3089 49.5737 81.3089C48.7853 81.3089 48.1114 81.0292 47.5501 80.4689C46.9898 79.9086 46.7101 79.2338 46.7101 78.4463V77.6282C46.7101 77.5175 46.67 77.4211 46.5889 77.3409C46.5078 77.2598 46.4123 77.2188 46.3016 77.2188C46.1909 77.2188 46.0945 77.2598 46.0143 77.3409C45.9331 77.4211 45.8921 77.5175 45.8921 77.6282V78.4463C45.8921 79.3884 46.2061 80.2074 46.8352 80.9032C47.4632 81.6 48.2402 82 49.1642 82.1012V82.945H47.5282C47.4174 82.945 47.322 82.986 47.2408 83.0672C47.1597 83.1483 47.1196 83.2437 47.1196 83.3545C47.1196 83.4652 47.1597 83.5616 47.2408 83.6427C47.322 83.7239 47.4174 83.764 47.5282 83.764H51.6183C51.729 83.764 51.8255 83.7239 51.9056 83.6427C51.9868 83.5616 52.0278 83.4652 52.0278 83.3545C52.0278 83.2447 51.9868 83.1483 51.9056 83.0672C51.8255 82.986 51.729 82.945 51.6183 82.945H49.9823V82.1012C50.9072 82 51.6832 81.6 52.3123 80.9032C52.9403 80.2074 53.2544 79.3884 53.2544 78.4463V77.6282C53.2544 77.5175 53.2143 77.4221 53.1332 77.3409Z",
    fill: "#16B4F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.644 78.8874C83.644 84.1373 79.3878 88.3945 74.136 88.3945C68.8851 88.3945 64.6298 84.1373 64.6298 78.8874C64.6298 73.6365 68.8851 69.3793 74.136 69.3793C79.3878 69.3793 83.644 73.6365 83.644 78.8874Z",
    fill: "#E9F9FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0811 82.181H70.709C70.0915 82.181 69.5903 81.6808 69.5903 81.0623V76.7125C69.5903 76.0939 70.0915 75.5938 70.709 75.5938H76.0811C76.6987 75.5938 77.1999 76.0939 77.1999 76.7125V81.0623C77.1999 81.6808 76.6987 82.181 76.0811 82.181Z",
    fill: "#16B4F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6234 81.4697L75.3862 78.8896L79.6234 76.3086V81.4697Z",
    fill: "#16B4F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M231.213 112.145L223.131 121.829L234.565 128.533L241.826 117.788C241.826 117.788 238.468 113 231.213 112.145Z",
    fill: "#FCD2BA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M231.214 112.147C231.214 112.147 236.363 96.5809 238.278 93.3489C240.194 90.1149 250.645 76.9624 251.124 76.6627C251.604 76.3639 253.4 77.8005 251.124 82.4109C248.85 87.0203 245.163 93.7307 245.163 93.7307C245.163 93.7307 254.503 94.3062 255.641 95.5634C256.778 96.8205 256.773 104.783 256.778 105.03C256.794 105.802 255.342 106.819 253.965 105.802C253.965 105.802 253.524 107.133 252.214 107.051C250.912 106.968 250.432 105.802 250.432 105.802C250.432 105.802 249.175 110.711 246.241 114.063C243.308 117.416 241.826 117.791 241.826 117.791L231.214 112.147Z",
    fill: "#FFD3BB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M241.615 113.175C241.615 113.175 245.296 109.8 244.967 103.715C244.967 103.715 250.031 102.089 251.228 99.0353C252.426 95.9818 250.941 93.6155 250.643 93.7348C250.343 93.8551 242.453 97.908 241.615 98.7461C240.777 99.5842 238.261 105.512 237.124 106.469",
    fill: "#FFD3BB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M241.615 113.175C241.615 113.175 245.296 109.801 244.967 103.716C244.967 103.716 250.266 99.3648 251.061 98.4074C253.157 95.8855 250.941 93.6157 250.643 93.735C250.343 93.8552 242.453 97.9082 241.615 98.7463C240.777 99.5843 238.261 105.512 237.124 106.469",
    stroke: "#ECA79E",
    strokeWidth: 2.65637,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M253.967 105.801L253.292 99.5073C252.921 97.9781 251.955 97.0312 251.955 97.0312",
    stroke: "#ECA79E",
    strokeWidth: 2.65637,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M250.434 105.797L250.191 99.7376",
    stroke: "#ECA79E",
    strokeWidth: 2.65637,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M250.432 105.802C250.432 105.802 250.358 107.095 248.726 107.089C247.704 107.084 247.259 106.381 247.259 106.381L246.694 102.281",
    stroke: "#ECA79E",
    strokeWidth: 2.65637,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M245.007 96.6875L244.539 95.3402",
    stroke: "#ECA79E",
    strokeWidth: 2.65637,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M167.658 89.0247C160.302 90.9633 158.066 115.147 159.901 119.29C161.737 123.434 181.598 162.597 185.657 168.027C189.715 173.457 200.689 174.702 204.928 170.134C206.858 168.053 237.377 126.135 237.377 126.135L226.774 116.769L199.408 138.598C199.408 138.598 185.048 105.12 181.471 98.444C177.893 91.7689 171.972 87.8878 167.658 89.0247Z",
    fill: "#5D6166"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M221.975 121.23L232.575 132.848",
    stroke: "#3F4347",
    strokeWidth: 2.65637,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M231.987 127.48C232.185 128.02 232.784 128.298 233.325 128.101C233.867 127.902 234.145 127.302 233.947 126.762C233.749 126.222 233.149 125.943 232.607 126.141C232.066 126.34 231.788 126.939 231.987 127.48Z",
    fill: "#3F4347"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M115.314 78.2502L142.365 81.3151L149.77 103.008L139.651 146.217L115.314 78.2502Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M130.515 87.0521L138.756 86.5586L140.1 90.8588L137.48 97.0632H132.24L128.499 90.9494L130.515 87.0521Z",
    fill: "#DD1948"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M116.091 62.9805L116.927 73.9719C116.927 73.9719 125.814 82.4395 134.243 85.3957C134.243 85.3957 137.412 83.9153 140.1 79.7048L141.977 63.3795C141.977 63.3795 131.231 57.6332 116.091 62.9805Z",
    fill: "#ECA79E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M116.093 62.9802C116.093 62.9802 119.47 80.8296 138.924 81.3423L140.103 79.7045L140.473 77.375L116.093 62.9802Z",
    fill: "#E08780"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M116.849 72.9885C116.849 72.9885 127.242 82.612 134.238 85.3894C134.238 85.3894 128.829 95.04 128.627 94.9719C128.426 94.9054 115.324 78.2714 115.324 78.2714C115.324 78.2714 115.684 76.1994 116.849 72.9885Z",
    fill: "#E1E1E2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M134.244 85.3957L140.146 94.038L142.648 82.8394L141.223 74.8672C141.223 74.8672 139.517 80.4875 138.04 82.1903C136.561 83.8923 134.244 85.3957 134.244 85.3957Z",
    fill: "#E1E1E2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M132.239 97.0625L128.499 121.721L140.1 151.821L144.164 123.985L137.479 97.0625H132.239Z",
    fill: "#DD1948"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M115.329 78.2773C115.329 78.2773 115.329 81.3423 116.927 86.9607C118.885 93.841 139.666 146.244 139.666 146.244C139.666 146.244 143.28 93.8133 143.684 89.1103C144.087 84.4073 142.078 79.6519 142.078 79.6519C142.078 79.6519 174.375 89.0769 176.607 90.5392C180.503 93.0926 171.231 130.186 170.29 142.011C169.35 153.836 169.798 197.729 169.798 197.729H91.9922C91.9922 197.729 91.6791 148.192 88.1855 133.814C84.6909 119.435 77.8374 97.282 77.0308 94.4595C76.2252 91.6379 115.329 78.2773 115.329 78.2773Z",
    fill: "#5D6166"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M152.506 44.2533C152.506 44.2533 152.774 59.1697 151.565 63.7381C150.356 68.3075 145.455 75.7519 142.499 77.2304C139.543 78.709 134.499 78.52 132.349 77.3106C130.199 76.1012 121.161 73.1212 117.801 65.5956C114.442 58.072 113.083 44.8298 115.955 33.638C118.508 23.687 132.215 22.2151 138.934 23.1553C145.653 24.0974 152.506 28.9064 152.506 44.2533Z",
    fill: "#FFD3BB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M140.82 54.7734C140.82 54.7734 142.204 59.6998 141.944 60.9044C141.683 62.109 140.469 62.9814 140.469 62.9814",
    stroke: "#ECA79E",
    strokeWidth: 1.34638,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M133.503 44.988C133.265 43.9409 127.613 41.8505 124.084 43.2822C120.851 44.5938 124.178 45.8786 126.845 46.142C128.54 46.31 133.941 46.9085 133.503 44.988Z",
    fill: "#5D6166"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M142.616 45.2552C142.733 44.188 147.05 41.8771 150.72 42.8927C154.083 43.8243 150.945 45.4795 148.326 46.0493C146.662 46.4111 142.402 47.2129 142.616 45.2552Z",
    fill: "#5D6166"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M148.56 54.3801C148.536 55.424 147.995 56.2576 147.353 56.2428C146.711 56.2281 146.209 55.3706 146.232 54.3266C146.256 53.2826 146.796 52.4481 147.44 52.4629C148.082 52.4786 148.584 53.3351 148.56 54.3801Z",
    fill: "#3F4347"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M132.823 54.3801C132.799 55.424 132.258 56.2576 131.616 56.2428C130.974 56.2281 130.472 55.3706 130.495 54.3266C130.519 53.2826 131.06 52.4481 131.703 52.4629C132.345 52.4786 132.847 53.3351 132.823 54.3801Z",
    fill: "#3F4347"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M142.538 65.864L130.865 65.5977C130.865 65.5977 129.794 71.9959 136.861 72.1572C143.929 72.3185 142.538 65.864 142.538 65.864Z",
    fill: "#75044A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M141.223 70.8483C141.223 70.8483 140.282 68.5421 136.945 68.466C133.608 68.389 132.43 70.6479 132.43 70.6479C132.43 70.6479 132.917 72.1943 136.602 72.2783C140.286 72.3623 141.223 70.8483 141.223 70.8483Z",
    fill: "#DD1948"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M130.825 66.966L130.857 65.5938L142.539 65.8621L142.508 67.2344L130.825 66.966Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.538 65.864L130.865 65.5977C130.865 65.5977 129.794 71.9959 136.861 72.1572C143.929 72.3185 142.538 65.864 142.538 65.864Z",
    stroke: "#E08780",
    strokeWidth: 1.34638,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M114.532 49.4425C114.532 49.4425 109.849 47.6957 107.45 52.8913C105.643 56.801 109.156 63.478 116.929 63.3777C116.929 63.3777 115.644 53.2788 114.532 49.4425Z",
    fill: "#FFD3BB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M136.824 56.4812L127.733 64.1844",
    stroke: "#ECA79E",
    strokeWidth: 0.654994,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M144.668 56.4805L149.786 63.3794",
    stroke: "#ECA79E",
    strokeWidth: 0.654994,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.936 59.1699H126.356C125.696 59.1699 125.162 58.6354 125.162 57.9768V53.5096C125.162 52.8509 125.696 52.3164 126.356 52.3164H136.936C137.594 52.3164 138.129 52.8509 138.129 53.5096V57.9768C138.129 58.6354 137.594 59.1699 136.936 59.1699Z",
    stroke: "#3F4347",
    strokeWidth: 1.34638,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.075 59.1699H144.495C143.836 59.1699 143.301 58.6354 143.301 57.9768V53.5096C143.301 52.8509 143.836 52.3164 144.495 52.3164H155.075C155.734 52.3164 156.269 52.8509 156.269 53.5096V57.9768C156.269 58.6354 155.734 59.1699 155.075 59.1699Z",
    stroke: "#3F4347",
    strokeWidth: 1.34638,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M138.128 54.9118C138.128 54.9118 138.822 53.5 140.793 53.5C142.765 53.5 143.302 54.9118 143.302 54.9118",
    stroke: "#3F4347",
    strokeWidth: 1.34638,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M125.163 53.5117L114.256 48.2416",
    stroke: "#3F4347",
    strokeWidth: 1.34638,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M116.039 55.1339C116.039 55.1339 118.062 46.6243 118.242 45.2812C118.421 43.9373 118.242 38.3819 116.994 36.9491C116.7 36.6112 125.63 29.9515 135.801 30.3199C153.227 30.9499 152.533 42.7956 152.533 42.7956C152.533 42.7956 157.481 34.3519 150.403 26.5581C141.612 16.8754 120.144 16.4859 112.893 27.0144C110.486 30.508 110.486 34.0016 110.486 34.0016C110.486 34.0016 106.605 37.3071 106.247 40.6222C105.888 43.9373 108.378 51.3358 108.378 51.3358C108.378 51.3358 111.808 47.8709 114.502 50.3412C115.236 51.0151 115.8 52.2216 116.039 55.1339Z",
    fill: "#858789"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M115.33 78.2773C115.33 78.2773 110.382 79.5306 108.824 81.3423C107.267 83.1521 108.745 106.669 109.417 109.76L119.707 108.685L113.922 115.001C113.922 115.001 132.559 139.593 139.666 146.244C139.666 146.244 121.927 96.7475 115.33 78.2773Z",
    fill: "#3F4347"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M141.977 79.3164C141.977 79.3164 145.537 80.06 148.074 82.9245C150.609 85.7891 155.106 107.073 155.106 107.073L146.372 108.148L153.091 110.876L139.667 146.244C139.667 146.244 142.206 110.959 141.977 79.3164Z",
    fill: "#3F4347"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M139.666 146.242L138.128 196.871",
    stroke: "#3F4347",
    strokeWidth: 2.65637,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M126.096 162.387C124.355 159.122 124.956 157.72 125.327 155.083C125.327 155.083 126.092 151.422 127.48 149.293C128.868 147.166 139.138 136.988 139.138 136.988C139.138 136.988 141.081 139.301 138.583 142.817C136.084 146.333 134.512 148.924 134.235 149.849C134.235 149.849 139.957 150.554 144.597 147.999C146.725 146.827 153.114 140.884 155.211 139.464C157.308 138.046 158.728 139.033 158.666 139.527C158.605 140.02 157.365 141.568 157.365 141.568C157.365 141.568 158.383 142.262 157.92 144.205C157.92 144.205 158.476 144.575 158.614 145.408C158.753 146.241 157.742 147.704 157.742 147.704C157.742 147.704 158.474 148.68 157.543 150.224C156.424 152.078 152.924 156.14 148.853 159.379C144.782 162.616 134.185 165.673 132.023 166.214C131.098 166.445 127.288 164.624 126.096 162.387Z",
    fill: "#FFD3BB"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M157.365 141.566C157.365 141.566 152.622 147.914 150.402 149.642C148.181 151.368 145.807 152.88 145.807 152.88",
    stroke: "#ECA79E",
    strokeWidth: 2.65637,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M157.923 144.203C157.923 144.203 154.006 149.695 151.601 151.646C149.466 153.377 146.981 155.081 146.981 155.081",
    stroke: "#ECA79E",
    strokeWidth: 2.65637,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M157.743 147.703C157.743 147.703 154.56 151.821 153.018 153.302C151.476 154.783 148.119 157.188 148.119 157.188",
    stroke: "#ECA79E",
    strokeWidth: 2.65637,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M120.134 156.443L125.329 155.084L132.026 166.215L123.606 170.137L120.134 156.443Z",
    fill: "#FFD3BB"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3485 93.7312C68.351 94.6036 66.0563 111.631 66.9287 120.553C67.7105 128.544 69.0029 177.572 71.0762 183.349C73.1494 189.125 78.1826 191.345 83.6435 190.603C89.1044 189.86 125.212 170.371 125.212 170.371L121.06 154.976L92.6858 159.604C92.6858 159.604 94.1443 128.839 92.9798 117.097C91.8162 105.355 87.5323 93.2081 80.3485 93.7312Z",
    fill: "#5D6166"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0317 94.4609C77.0317 94.4609 87.6929 95.09 91.0395 106.574C94.3861 118.059 92.686 159.605 92.686 159.605L121.06 154.976L125.213 170.372L91.8461 187.406",
    stroke: "#3F4347",
    strokeWidth: 2.65637,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M111.956 156.457L116.091 174.151",
    stroke: "#3F4347",
    strokeWidth: 2.65637,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M121.492 167.319C121.492 167.919 121.005 168.406 120.404 168.406C119.804 168.406 119.317 167.919 119.317 167.319C119.317 166.719 119.804 166.232 120.404 166.232C121.005 166.232 121.492 166.719 121.492 167.319Z",
    fill: "#3F4347"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M177.303 91.8063C177.303 91.8063 169.519 128.752 169.707 140.057",
    stroke: "#3F4347",
    strokeWidth: 2.65637,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent3);
export default __webpack_public_path__ + "static/media/Component3.64bbc4210b4e50c81ed9894162080f67.svg";
export { ForwardRef as ReactComponent };